export default "__VITE_ASSET__1Q5Rl7Yu__"